import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: -80px;
  margin-bottom: 48px;
  gap: 40px;
  width: 100%;
  max-width: 840px;
  padding: 0px 20px;
  position: relative;
  min-height: 60vh;
  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    min-height: 35vh;
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    min-height: 40vh;
  }
`;

export const WrapperCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 840px;
`;
